import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { api, formatPrice } from "../../lib/api";
import { Plus, Search, Pencil, Trash2, Upload } from "lucide-react";
import { toast } from "sonner";

export default function AdminProducts() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [importing, setImporting] = useState(false);
  const fileRef = useRef();

  const load = (s = "") => api.get("/admin/products", { params: { search: s, limit: 100 } })
    .then(({ data }) => { setItems(data.items); setTotal(data.total); });

  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Изтриване на картината?")) return;
    await api.delete(`/admin/products/${id}`);
    toast.success("Изтрито");
    load(search);
  };

  const onImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImporting(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/admin/import-csv?replace=false", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(`Импортирани ${data.inserted} картини`);
      load();
    } catch { toast.error("Грешка при импорт"); }
    finally { setImporting(false); e.target.value = ""; }
  };

  return (
    <div data-testid="admin-products">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <h1 className="font-serif text-3xl text-navy">Картини <span className="text-base text-charcoal/40">({total})</span></h1>
        <div className="flex gap-2">
          <input ref={fileRef} type="file" accept=".csv" onChange={onImport} className="hidden" data-testid="csv-input" />
          <button onClick={() => fileRef.current?.click()} disabled={importing} className="btn-navy-outline px-4 py-2.5 rounded-sm flex items-center gap-2 text-sm" data-testid="import-csv-btn">
            <Upload size={16} /> {importing ? "Импорт..." : "Импорт от WordPress"}
          </button>
          <Link to="/admin/products/new" className="btn-gold px-4 py-2.5 rounded-sm flex items-center gap-2 text-sm" data-testid="new-product-btn"><Plus size={16} /> Нова</Link>
        </div>
      </div>

      <div className="relative mb-5 max-w-md">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-charcoal/40" />
        <input value={search} onChange={(e) => { setSearch(e.target.value); load(e.target.value); }} placeholder="Търси по име..." className="w-full border border-stone pl-10 pr-4 py-2.5 outline-none focus:border-gold" data-testid="admin-search" />
      </div>

      <div className="bg-white border border-stone overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-stone text-navy">
            <tr><th className="text-left p-3">Картина</th><th className="text-left p-3 hidden md:table-cell">Категория</th><th className="text-left p-3">Цена</th><th className="text-right p-3">Действия</th></tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.id} className="border-t border-stone hover:bg-ivory" data-testid={`product-row-${p.id}`}>
                <td className="p-3"><div className="flex items-center gap-3"><img src={p.images?.[0] || "https://via.placeholder.com/60"} alt="" className="w-12 h-14 object-cover bg-stone" /><span className="text-navy font-medium line-clamp-1">{p.title}</span></div></td>
                <td className="p-3 hidden md:table-cell text-charcoal/60">{p.category_label}</td>
                <td className="p-3 text-navy">{formatPrice(p.price)}</td>
                <td className="p-3"><div className="flex justify-end gap-2">
                  <Link to={`/admin/products/${p.id}`} className="p-2 text-navy hover:text-gold" data-testid={`edit-${p.id}`}><Pencil size={16} /></Link>
                  <button onClick={() => del(p.id)} className="p-2 text-charcoal/40 hover:text-red-500" data-testid={`delete-${p.id}`}><Trash2 size={16} /></button>
                </div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
